import { useEffect, useState } from "react";
import { DataTable } from "../../../components/data-table";
import { dataDecrypt, encrypt } from "../../../app/utility/encryption-helper";
import { ApisService } from "../../../app/core/apis.service";
import { useLocation, useNavigate } from "react-router-dom";
import { FormatIndianDate } from "../../../app/utility/formatIndianDate";
import { OrganizationDataGridCols } from "./data-grid-cols";


export const OrganizationsList = () => {
  // const { startDate, endDate } = getMonthStartAndEndDates();
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const params = location.search.replace("?", "");
  const [organizationData, setOrganizationData] = useState<any>([]);
  const initialPayload = { filters: { limit: 10, page: 0 ,
    // DateFrom: startDate, DateTo: endDate
  } }
  const [pageCount, setPageCount] = useState(initialPayload);
  // const [fromDate, setFromDate] = useState<any>(startDate);
  // const [toDate, setToDate] = useState<any>(endDate);
  const [locationPath, setLocationPath] = useState<boolean>(false);

  useEffect(() => {
    loadOrgs(initialPayload);
    if (location.pathname === "/dashboard/subscriptions") {
      setLocationPath(true);
    }
    else {
      setLocationPath(false);
    }

  }, [location]);

  async function loadOrgs(data: any): Promise<void> {
    setLoading(true);
    try {
      let encrytedData = encrypt(JSON.stringify(data));
      const res = await ApisService.getOrganizationData("getBuDetails", encrytedData);
      const organizationData = JSON.parse(dataDecrypt(res.data.data));
      // if (organizationData) {
        organizationData?.results?.forEach((element: any) => {
          element.users_count = element?.users?.length;
          element.created_date = FormatIndianDate(element?.created_date, "dateWithTime");
        });
        setOrganizationData(organizationData);
      // }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }
  const handleInput = (e: any) => {
    const value = e.target.value;
    setSearchText(value);
    let payload = { filters: { limit: 10, page: 0, search: value ,
      // DateFrom: fromDate, DateTo: toDate 
    } }
    loadOrgs(payload);
    setPageCount(payload);
  };

  const onSelectPaginator = (data: any) => {
    const pageData = { ...pageCount, page: data };
    let payload = { filters: { limit: pageData.filters.limit, page: data,search: searchText
      // DateFrom: fromDate, DateTo: toDate
    } }
    setPageCount(payload);
    loadOrgs(payload);
  };

  const onActions = (e: any) => {
    if (e.type === "link" && !locationPath) {
      navigate(`/dashboard/organizations/org-details/${pageCount?.filters?.page}/${e.data._id}/details`)
    }
    else if(e.type === "view"){
      navigate(`/dashboard/subscriptions/${e.data._id}/view`)
    }
  }

  // const selectFromDate = (e: any) => {
  //   setFromDate(e.target.value);
  // }

  // const selectToDate = (e: any) => {
  //   setToDate(e.target.value)
  // }

  const searchData = () => {
    let payload = { filters: { limit: 10, page: 0, search: searchText,
      //  DateFrom: fromDate, DateTo: toDate
       } };
    setPageCount(payload);
    loadOrgs(payload);
  }

  const handleClose = () => {
    setSearchText("");
    // setFromDate(startDate);
    // setToDate(endDate);
    setPageCount(initialPayload);
    loadOrgs(initialPayload);
  }

  const gridCol = OrganizationDataGridCols();

  return (
    <div className="container-fluid content-bg-color">
      <div className="row">
        <div className="col-12">
          <div className="row">
            <div className="col-12 text-end d-flex justify-content-between pl-8 align-items">
              <h4 className="primary-color fw-bold mt-3 mb-1">{locationPath ? `Subscriptions` : `Business Units`}</h4>
               {!loading && (<h6 className="mt-3 fw-bold">Number of BUs: {organizationData.total || 0 }</h6>)}
            </div>
          </div>
          <div className="row">
            <div className="col-md-9 px-0 mb-2">
              <input type="text" className="form-control p-2 rounded-4" placeholder="Search . . ." value={searchText} onChange={(e) => handleInput(e)} />
            </div>
            <div className="col-md-3 px-0 mb-2 d-flex">
           <button className="form-control primary-bg text-white w-100 ms-1" onClick={searchData}>Search</button>
           <button className="form-control primary-bg text-white w-100" onClick={handleClose}>Clear</button>
            </div>
          </div>
          
          <div className="row ">
            <div className="col-12 px-0">
              {loading && (
                <div className="text-center p-5">
                  <div className="spinner-border" role="status">
                    <span className="sr-only"></span>
                  </div>
                </div>
              )}
              {!loading && (
                <>
                  <DataTable
                    tableData={organizationData}
                    TableCols={gridCol}
                    pagination={true}
                    pageCount={pageCount}
                    onSelectPageChange={(e) => onSelectPaginator(e)}
                    onActions={(e) => onActions(e)}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
